import { useEffect, useRef } from 'react'
import { usePriceIntentValueOrThrow } from '@/features/priceCalculator/usePriceIntent'
import type { PriceIntent } from '@/services/priceIntent/priceIntent.types'
import { useTracking } from '@/services/Tracking/useTracking'
import { FetchedInsuranceCard } from './FetchedInsuranceCard'

export function CurrentInsuranceFieldReadOnly() {
  const priceIntent = usePriceIntentValueOrThrow()

  useReportInsurelyPrompted()

  if (!hasExternalInsurer(priceIntent) || !priceIntent.hasCollectedInsurelyData) {
    return null
  }

  return (
    <FetchedInsuranceCard
      insuranceCompany={priceIntent.externalInsurer.displayName}
      hasFetchedInsurances={(priceIntent.fetchedExternalInsurances?.length ?? 0) > 0}
    />
  )
}

function useReportInsurelyPrompted() {
  const priceIntent = usePriceIntentValueOrThrow()
  const tracking = useTracking()
  const reported = useRef(false)

  useEffect(() => {
    if (hasExternalInsurer(priceIntent) && !reported.current) {
      tracking.reportInsurelyPrompted({
        id: priceIntent.product.id,
        displayNameFull: priceIntent.product.displayNameFull,
      })
      reported.current = true
    }
  }, [priceIntent, tracking])
}

function hasExternalInsurer(
  priceIntent: PriceIntent,
): priceIntent is PriceIntent & { externalInsurer: NonNullable<PriceIntent['externalInsurer']> } {
  return priceIntent.externalInsurer != null
}
